import React from "react";
import { Link } from "../../libraries/universal-route/router";
import HiringFooter from "./HiringFooter";
import Logo from "./job_description/Logo";

const JobRow = ({ id, name, baseUrl }) => (
  <tr key={id} className="bg-white">
    <td className="px-6 py-4 text-sm font-medium text-gray-900 capitalize whitespace-nowrap">
      <Link
        to={`${baseUrl}/${id}`}
        className="hover:underline text-blue-600 text-lg"
      >
        {name}
      </Link>
    </td>
  </tr>
);

const Category = ({ name, id, subcategories, baseUrl }) => (
  <div key={id}>
    <h3 className="mb-4 text-2xl font-bold sm:truncate">{name}</h3>

    <div className="flex flex-col mb-10">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="overflow-hidden border-b border-gray-200 mb-8">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-100">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-sm font-medium tracking-wider text-left text-gray-900 uppercase"
                  >
                    Job Title
                  </th>
                </tr>
              </thead>
              <tbody>
                {subcategories
                  .reduce(
                    (acc, { name: subcategoryName, jobs }) =>
                      acc.concat(
                        jobs.map((data) => ({ ...data, team: subcategoryName }))
                      ),
                    []
                  )
                  .map(({ id: jobId, name: jobName, team }, index) => (
                    <JobRow
                      key={jobId}
                      id={jobId}
                      name={jobName}
                      team={team}
                      odd={index % 2 === 1}
                      baseUrl={baseUrl}
                    />
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const Jobs = ({
  categories,
  baseUrl,
  logo,
  name,
  url,
  colorHeaderBg,
  colorHeaderText
}) => (
  <>
    <div
      className="pt-4 pb-6 mb-8 xl:pt-6 xl:pb-10 xl:mb-10"
      style={{ backgroundColor: colorHeaderBg }}
    >
      <div className="container">
        <div className="mb-4 xl:mb-8">
          <a
            href={url}
            className="text-xs font-medium underline xl:text-lg"
            style={{ color: colorHeaderText }}
          >
            Home
          </a>
        </div>
        <div className="mb-4 xl:mb-5">
          <Logo
            logo={logo}
            name={name}
            colorHeaderText={colorHeaderText}
            url={url}
          />
        </div>

        <h1
          className="mb-2 text-3xl font-semibold xl:text-5xl py-4"
          style={{ color: colorHeaderText }}
        >
          Current Opportunities
        </h1>
        <div className="flex items-center justify-between space-x-3"></div>
      </div>
    </div>

    <div className="container">
      <section>
        {categories.map(({ name, id, subcategories }) => (
          <Category
            key={id}
            name={name}
            id={id}
            subcategories={subcategories}
            baseUrl={baseUrl}
          />
        ))}
      </section>
    </div>

    <HiringFooter />
  </>
);

export default Jobs;
